const getDistribute = state => state.Distributee.Distributor

const selectors = {
    getDistribute,
}

export default selectors